import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Activity, BusinessUnitRole, ProviderBu } from '@dal/core';
import { ProviderBusinessUnitInlineSelectorComponent } from '../provider-business-unit-inline-selector/provider-business-unit-inline-selector.component';

@Component({
  selector: 'dal-shared-ui-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  showSideNav = false;
  @Input() user = { name: 'User' };
  @Input() businessUnit: ProviderBu | null = null;
  @Input() businessUnits: BusinessUnitRole[] = [];
  @Input() title = 'DAL | Media and Metadata Administration';
  @Input() showActivityQueue = false;
  @Input() activities: Activity[] | null = [];
  @Output() deleteActivity: EventEmitter<Activity> = new EventEmitter();
  @Output() pauseActivity: EventEmitter<Activity> = new EventEmitter();
  @Output() resumeActivity: EventEmitter<Activity> = new EventEmitter();
  @Output() cancelActivity: EventEmitter<Activity> = new EventEmitter();
  @Output() searchEvent: EventEmitter<string> = new EventEmitter();
  @Output() toggleSideNavEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() businessUnitChange: EventEmitter<number> = new EventEmitter();

  @ViewChild(ProviderBusinessUnitInlineSelectorComponent) private buSelector?: ProviderBusinessUnitInlineSelectorComponent;


  searchText: string = '';
  search(searchText: string) {
    const trimmedText = searchText.trim();
    this.searchEvent.emit(trimmedText);
  }

  toggleSideNav() {
    this.showSideNav = !this.showSideNav;
    this.toggleSideNavEvent.emit(this.showSideNav);
  }

  deleteActivityQueue(activity: Activity) {
    this.deleteActivity.emit(activity);
  }

  pauseActivityQueue(activity: Activity) {
    this.pauseActivity.emit(activity);
  }

  resumeActivityQueue(activity: Activity) {
    this.resumeActivity.emit(activity);
  }

  cancelActivityQueue(activity: Activity) {
    this.cancelActivity.emit(activity);
  }

  toggleActivityQueue() {
    this.showActivityQueue = !this.showActivityQueue;
  }

  revertBusinessUnitSelection() {
    this.buSelector?.revertSelection();
  }
}
